import { cn } from 'utils/styles';
import Link from 'components/shared/Link/Link';

interface ArticleTagProps {
  label: string;
  href?: string;
  className?: string;
}

const tagClassName = 'block w-fit font-serif font-normal text-base px-2 py-1 border border-current rounded-sm';

export const ArticleTag = ({ label, href, className }: ArticleTagProps) => {
  const classes = cn(tagClassName, className);

  if (href) {
    return (
      <Link href={href} className={classes}>
        {label}
      </Link>
    );
  }

  return <span className={classes}>{label}</span>;
};
